module.exports = __webpack_public_path__ + "img/tick.cf832ea0.png";